import React from 'react'
import './testimonials.css'

import AVTR1 from '../../assets/avatar1.png'
import AVTR2 from '../../assets/avatar2.png'
import AVTR3 from '../../assets/avatar3.png'
import AVTR4 from '../../assets/avatar4.png'
import AVTR5 from '../../assets/avatar5.png'
import AVTR6 from '../../assets/avatar6.png'
import AVTR7 from '../../assets/avatar7.png'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Navigation } from 'swiper/core'

import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'

SwiperCore.use([Pagination, Navigation])

const data = [
  { avatar: AVTR6, name: 'DevOps Expert', review: 'Microsoft / 2025' },
  { avatar: AVTR5, name: 'Azure Administrator', review: 'Microsoft / 2025' },
  { avatar: AVTR7, name: 'ITIL v4', review: 'PeopleCert / 2024' },
  { avatar: AVTR4, name: 'Azure Fundamentals', review: 'Microsoft / 2022' },
  { avatar: AVTR3, name: 'Power Platform Fundamentals', review: 'Microsoft / 2022' },
  { avatar: AVTR1, name: 'Dynamics 365 Fundamentals (ERP)', review: 'Microsoft / 2022' },
  { avatar: AVTR2, name: 'Dynamics 365 Fundamentals (CRM)', review: 'Microsoft / 2022' },
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h2>Certificates</h2>

      <Swiper
        className="container testimonials_container"
        spaceBetween={40}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        grabCursor={true}
      >
        {data.map(({ avatar, name, review }, index) => (
          <SwiperSlide key={index} className="testimonial">
            <div className="client_avatar">
              <img src={avatar} alt={name} />
            </div>
            <h5 className='client_name'>{name}</h5>
            <small className='client_review'>{review}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default Testimonials
